import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_DOMAIN_URI } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class ExcelqandaService {

  constructor(private http:HttpClient) { }

  uploadSummaryPdf(payload:any){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/upload_excel",payload);
  }

  // saveSheetForm(payload:any){
  //   return this.http.post("https://gpt.canstringai.com/pdf/fill_data",payload,{ responseType: 'blob' });
  // }

  getSheetData(payload:any){
    return this.http.post(BASE_DOMAIN_URI +"/pdf/fill_data",payload);
  }

  downloadSheet(payload:any){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/dowload_excel",payload,{ responseType: 'blob' });
  }

  getFiles(payload:any){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/getFiles",payload);
  }

  deleteFiles(payload:any){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/deleteFiles",payload);
  }
}
